import moment from 'moment';

const states = {
  event_details: {
    events: [],
    analytics: {
      histogram: [],
      histogram_axis: {
        x_axis: 'EventTags',
        y_axis: 'Count'
      },
      histogram_scale: {
        EventTags: { alias: 'Event Tags' },
        Count: { alias: 'Count' }
      },
      histogram_filters: {
        startDate: moment(new Date(), "DD-MM-YYYY").subtract(1, 'days'),
        endDate: moment(new Date(), "DD-MM-YYYY"),
      },
    },
    loaders: {
      events_loading: false,
      events_loaded: false,
      event_updating: false,
      histogram_loading: false,
      histogram_load_error: false,
    }
  }
};

export default states;



// WEBPACK FOOTER //
// ./src/data/redux/event_details/states.js